var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
Array.prototype.insert = function(elementsToInsert, position) {
  let pos = position;
  if (pos === void 0 || pos === null || pos < 0) {
    pos = this.length;
  }
  this.splice(pos, 0, ...elementsToInsert);
  return this;
};
Array.prototype.padStart = function(len, value) {
  if (len <= this.length) {
    return this;
  }
  return Array(len - this.length).fill(value).concat(this);
};
const removeEmptyFilter = /* @__PURE__ */ __name(function(item) {
  return !!item;
}, "removeEmptyFilter");
Array.prototype.removeEmpty = function() {
  return this.filter(removeEmptyFilter);
};
Array.prototype.unique = function() {
  return Array.from(new Set(this));
};
Array.prototype.shuffleInPlace = function() {
  for (let i = this.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [this[i], this[j]] = [this[j], this[i]];
  }
};
Array.prototype.shuffle = function() {
  const result = [...this];
  result.shuffleInPlace();
  return result;
};
Array.prototype.splitEvenly = function(n) {
  return splitEvenly(this, n);
};
function entries(obj) {
  return Object.entries(obj);
}
__name(entries, "entries");
function keys(obj) {
  return Object.keys(obj);
}
__name(keys, "keys");
function splitEvenly(arr, n) {
  if (n <= 0) throw new RangeError(`splitEvenly: n must be positive, got ${n}`);
  if (arr.length === 0) return [];
  const result = [];
  const base = Math.floor(arr.length / n);
  const remainder = arr.length % n;
  let idx = 0;
  for (let i = 0; i < n; i++) {
    const size = base + (i < remainder ? 1 : 0);
    result.push(arr.slice(idx, idx + size));
    idx += size;
  }
  return result;
}
__name(splitEvenly, "splitEvenly");
export {
  entries,
  keys,
  removeEmptyFilter,
  splitEvenly
};
//# sourceMappingURL=array.js.map
